import Vue from 'vue'
import VueAxios from 'vue-axios'
import axiosInterceptor from '@/utils/axiosInterceptor'
import ElementUI from 'element-ui'
import i18n from '@/lang'
import moment from 'moment'
import * as filters from '@/filters'
import auth from '@/utils/auth'

// 框架样式
// import '@/assets/styles/index.scss'

// 矢量图标
// import '@/assets/icons/icon.css'
// require('@/assets/icons/iconfont')


const register = {} as any;

register.install = function  (Vue): void {

  if (register.installed) {
    return;
  }
  register.installed = true;

  // 加载axios拦截器
  Vue.use(VueAxios, axiosInterceptor)

  // 注册为Vue属性对象
  Object.defineProperties(Vue['prototype'], {
    $signalr: {
      get() {
        // return signalr;
        return null;
      }
    },
    $auth: {
      get() {
        return auth;
      }
    },
    $moment: {
      get() {
        // return moment;
        return null;
      }
    }
  })

  // 注册ElementtUI组件
  Vue.use(ElementUI, {
    size: 'mini', // 默认组件展示大小
    i18n: (key, value) => i18n.t(key, value) // 添加本地化支持
  });

  // 注册全局过滤器
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
  })

  // 处理日期转字符的问题
  Date.prototype.toString = function () {
    return moment(this).format('YYYY-MM-DD HH:mm:ss')
  }
  // 处理日期转JSON的问题
  Date.prototype.toJSON = function () {
    return moment(this).format('YYYY-MM-DD HH:mm:ss')
  }
}

if (typeof window !== 'undefined' && (window as any).Vue) {
  register.install((window as any).Vue)
}

export default register
